<script>
	export let change;
	export let id = "cb";
	export let name = null;
	export let label = "";
	export let value = null;
	export let checked = null;
	export let required = null;
	export let disabled = null;
	export let validator = null;
	export let validatorValue = null;
	export let validatorMessage = null;
	export let validatorTarget = null;
</script>

<input
	type="checkbox"
	on:change={change}
	bind:checked
	{value}
	{id}
	{name}
	data-validator={validator}
	data-validator-value={validatorValue}
	data-bouncer-message={validatorMessage}
	data-bouncer-target={validatorTarget}
	{required}
	{disabled}
/>
<label for={id}>
	{@html label}
	{#if required}
		<span class="required">*</span>
	{/if}
</label>

<style>
	span.required {
		color: red;
		left: 4px;
		margin-left: 4px;
		font-size: 1.2em;
	}

	/* Base for label styling */
	[type="checkbox"]:not(:checked),
	[type="checkbox"]:checked {
		position: absolute;
		left: -9999px;
	}

	[type="checkbox"]:not(:checked) + label,
	[type="checkbox"]:checked + label {
		position: relative;
		padding-left: 2.95em;
		cursor: pointer;
		display: inline;
	}

	/* checkbox aspect */
	[type="checkbox"]:not(:checked) + label:before,
	[type="checkbox"]:checked + label:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 20px;
		height: 20px;
		border: 2px solid #ccc;
		background: #fff;
		border-radius: 4px;
		box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
	}
	/* checkbox aspect */
	[type="checkbox"]:checked + label:before {
		content: "";
		border: 2px solid #e46937;
	}
	/* checked mark aspect */
	/*[type="checkbox"]:not(:checked) + label:after,*/
	[type="checkbox"]:checked + label:after {
		content: "";
		position: absolute;
		top: 2px;
		left: 6px;
		color: #e46937;
		font-size: 1.4em;
		transition: all 0.2s;
		border-bottom: 3px solid #e46937;
		border-right: 3px solid #e46937;
		transform: rotate(35deg);
		width: 7px;
		height: 14px;
	}
	[type="checkbox"]:disabled:checked + label:after {
		border-bottom: 3px solid #999;
		border-right: 3px solid #999;
	}
	/*[type="checkbox"]:not(:checked) + label:after,
        [type="checkbox"]:checked + label:after {
            content: '\2713\0020';
            position: absolute;
            top: 0;
            left: .22em;
            line-height: 0.8;
            color: #E46937;
            font-size: 1.4em;
            transition: all .2s;
            font-family: 'Lucida Sans Unicode', 'Arial Unicode MS', Arial;
        }*/
	/* checked mark aspect changes */
	/*[type="checkbox"]:not(:checked) + label:after {
                opacity: 0;
            }

            [type="checkbox"]:checked + label:after {
                opacity: 1;
            }*/

	/* disabled checkbox */
	[type="checkbox"]:disabled:not(:checked) + label:before,
	[type="checkbox"]:disabled:checked + label:before {
		box-shadow: none;
		border-color: #ccc;
		background-color: #ddd;
	}

	[type="checkbox"]:disabled:checked + label:after {
		color: #999;
	}

	[type="checkbox"]:disabled + label {
		cursor: default;
	}
	/* accessibility */
	/*[type="checkbox"]:checked:focus + label:before,
    [type="checkbox"]:not(:checked):focus + label:before {
        border: 2px dotted blue;
    }*/

	/* hover style just for information */
	[type="checkbox"]:disabled:not(:checked) + label:before,
	[type="checkbox"]:disabled:checked + label:before {
		box-shadow: none;
		border-color: #ccc;
		background-color: #ddd;
	}

	/* hover style just for information */
	label:hover:before {
		border: 2px solid #e46937 !important;
	}

	[type="checkbox"]:disabled:not(:checked) + label:hover:before,
	[type="checkbox"]:disabled:checked + label:hover:before {
		border: 2px solid #ccc !important;
		cursor: default;
	}
</style>
